export default __webpack_public_path__ + "static/media/promo_00.b0cb21e1.jpg";